import React, { useState } from 'react';
import { Dialogs, Dialog, Popup, Flex, Text, Button } from '@leverege/ui-elements';
import { ExportEditor, ExportModelCreatorFactory, Exporter } from '@leverege/ui-attributes';
import { ExportSettingsEditor } from '@leverege/molten/data-viewers';
import S from './ExportBillingDeviceCSV.css';
import ApiServerBillingItemIterator from './iterators/ApiServerBillingItemIterator';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ExportAction(molten) {
  return {
    id: 'recovr.billing.export',
    matches: {
      use: 'actionBar',
      objectType: 'bill',
      client: ['TableDataViewer', 'ListDataViewer']
    },
    handles: context => {
      const {
        clientProps
      } = context;
      const {
        objectType
      } = clientProps;
      let {
        model
      } = clientProps;
      model = model?.model || model;
      const exportModel = ExportModelCreatorFactory.create(model, objectType);
      return exportModel != null;
    },
    layout: {
      sort: 'zzzz'
    },
    customComponent: ({
      context
    }) => {
      const api = molten.get('api');
      const {
        clientProps
      } = context;
      const {
        settingsPath,
        objectType,
        delegate,
        model,
        relationship,
        filters
      } = clientProps;
      const [opened, setOpened] = useState(false);
      const url = `v1/interface/${delegate.getUrl(true)}`;
      const exportModel = ExportModelCreatorFactory.create(model, objectType);
      const onSave = ({
        value
      }) => {
        const iterator = new ApiServerBillingItemIterator({
          api,
          url,
          delegate,
          path: relationship.path,
          filters,
          ref: delegate.getInterfaceUrl(),
          objectType
        });
        new Exporter(value).export(iterator);
        setOpened(false);
      };
      const openAdvanced = () => {
        Dialogs.show({
          component: props => {
            const {
              show,
              onClose,
              onSave: pOnSave
            } = props;
            const onSave = evt => {
              pOnSave(evt);
              onClose();
            };
            return /*#__PURE__*/_jsx(Dialog, {
              show: show,
              closeOnEscape: false,
              closeOnDocumentClick: false,
              onClose: onClose,
              children: /*#__PURE__*/_jsx(ExportSettingsEditor, {
                ...props,
                onSave: onSave
              })
            });
          },
          props: {
            editor: ExportEditor,
            settingsPath: `${settingsPath}.export`,
            versionsPath: `${objectType}.export`,
            title: 'Edit Export Options',
            modelName: 'Export Options',
            editorProps: {
              objectType
            },
            value: exportModel,
            onSave
          }
        });
      };
      return /*#__PURE__*/_jsx(Popup, {
        className: S.popup,
        toggleVariant: "actionBar",
        opened: opened,
        onChange: ({
          isOpened
        }) => setOpened(isOpened),
        icon: "fa fa-fw fa-download",
        children: /*#__PURE__*/_jsx(ExportSettingsEditor, {
          simple: true,
          title: /*#__PURE__*/_jsxs(Flex, {
            align: "center",
            variant: "rowL",
            children: [/*#__PURE__*/_jsx(Text, {
              variant: "formTitle",
              children: "Export"
            }), /*#__PURE__*/_jsx(Button, {
              variant: "link",
              onClick: openAdvanced,
              children: "Advanced"
            })]
          }),
          onClose: () => setOpened(false),
          editor: ExportEditor,
          settingsPath: `${settingsPath}.export`,
          versionsPath: `${objectType}.export`,
          editorProps: {
            objectType
          },
          onSave: onSave,
          value: exportModel
        })
      });
    }
  };
}